const PERSISTED_THEME_KEY = 'external-users-frontend:pspTheme'

type PersistedTheme = {
  primaryColor?: string
  hoverbutton?: string
  secondaryColor?: string
}

export function savePspTheme(theme: Record<string, any>): void {
  try {
    const minimal: PersistedTheme = {
      primaryColor: theme.primaryColor,
      hoverbutton: theme.hoverbutton,
      secondaryColor: theme.secondaryColor,
    }
    localStorage.setItem(PERSISTED_THEME_KEY, JSON.stringify(minimal))
  } catch {
    // localStorage non disponibile (modalità privata, quota esaurita, ecc.)
  }
}

export function loadPspTheme(): Record<string, any> {
  try {
    const raw = localStorage.getItem(PERSISTED_THEME_KEY)
    if (!raw) return {}
    return JSON.parse(raw)
  } catch {
    return {}
  }
}
